import { createTabCountContext } from '../shared/createTabCountContext';

import type { DealInformationTab } from './types';

const { Provider, useTabCounts, useTabCount } = createTabCountContext<DealInformationTab>('DealInformationTabCount');

export const DealInformationTabCountProvider = Provider;
export const useDealInformationTabCounts = useTabCounts;
export const useDealInformationTabCount = useTabCount;
